<template>
  <el-dialog
    :title="tipParmas.title"
    width="30%"
    :before-close="handleClose"
    :visible.sync="tipParmas.tipsVisible"
    :close-on-click-modal="false"
  >
    <div class="content_title" v-html=" tipParmas.tipsContentTitle" />
    <div class="content_text" v-html=" tipParmas.tipsContentText" />
    <span slot="footer" class="dialog-footer">
      <el-button v-if="tipParmas.cancelText" class="cancel" @click="handleClose">{{ tipParmas.cancelText }}</el-button>
      <el-button v-if="tipParmas.confirmText" class="sure" type="primary" @click="confirm">{{ tipParmas.confirmText }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tipParmas: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm',this.tipParmas.type)
    },
  }
}
</script>
  <style lang="scss" scoped>
.content_title{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: #606060;
    line-height: 22px;
    margin-bottom: 10px;
}
.content_text{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #606060;
    line-height: 22px;
}
  </style>

